module.exports = __webpack_public_path__ + "img/HongKongTrustSwper3.f319cc84.png";